import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useDebounce } from 'react-use';
import { FormControlLabel, Checkbox } from '@material-ui/core';

import { PosPlugin } from 'plugins/plugin';
import { getProductsInShoppingCart } from 'reducers/ShoppingCart';
import { getModalPopups } from 'reducers/modalPage';
import UIButton from 'components/UIElements/UIButton';
import { getPluginConfiguration } from 'reducers/Plugins';

const customerSearchAutoFocus: PosPlugin = {
  id: 'customer-search-autofocus',
  name: 'Customer search autofocus',
  info:
    'This plugin will autofocus customer search on initial load and after new sale',
  keywords: ['customer search', 'customer', 'search', 'autofocus'],
  ComponentConfiguration: ({
    current = { showAutomaticResults: true },
    save,
  }) => {
    const [showAutomaticResults, toggleAutoclick] = useState<boolean>(
      current.showAutomaticResults,
    );

    return (
      <>
        <FormControlLabel
          control={
            <Checkbox
              checked={showAutomaticResults}
              onChange={() => toggleAutoclick(prev => !prev)}
              color="primary"
            />
          }
          label="Display customer results table automatically"
        />
        <UIButton
          variant="POS"
          type="button"
          text="Save"
          action={() =>
            save({
              showAutomaticResults,
            })
          }
        />
      </>
    );
  },
  ComponentHeader: ({ children }) => {
    const shoppingCart = useSelector(getProductsInShoppingCart);
    const isCartEmpty = shoppingCart.length === 0;
    const modals = useSelector(getModalPopups);
    const isConfirmationOpened = modals.some(
      ({ component }) => component === 'PaymentConfirmation',
    );

    const input = document.getElementById('customer-search-input');

    const { activeElement } = document;

    const isSomeInputFocused = activeElement?.tagName === 'INPUT';

    const shouldFocus = !isSomeInputFocused && activeElement !== input;

    useDebounce(
      () => {
        if (isCartEmpty && !isConfirmationOpened && shouldFocus) {
          input?.focus();
          input?.click();
        }
      },
      250,
      [isCartEmpty, isConfirmationOpened, shouldFocus],
    );

    return children;
  },
  UICustomerResults: ({ searchValue, children }) => {
    const config = useSelector(
      getPluginConfiguration<Record<string, boolean>>(
        'customer-search-autofocus',
      ),
    );

    const showAutomaticResults = config?.showAutomaticResults ?? true;

    return showAutomaticResults || showAutomaticResults === undefined || searchValue?.length ? children : null;
  },
};

export default customerSearchAutoFocus;
